import React from "react";
import * as styles from "./empty-state.module.scss";
import EmptyStateIcon from "../empty-state-icon/empty-state-icon";

export interface EmptyStateProps {
	src: string;
	title: string;
	subtitle: string;
}

export default function EmptyState(props: EmptyStateProps) {
	return (
		<div className={styles.emptyContent}>
			<EmptyStateIcon src={props.src} />
			<span className={styles.emptyTitle}>{props.title}</span>
			<span className={styles.emptySubtitle}>{props.subtitle}</span>
		</div>
	);
}
